import validationMessages from 'vee-validate/dist/locale/de';
//citrix.de

const yesNoOptions = [
    {value: "Yes", text: "Ja"},
    {value: "No", text: "Nein"}
]

export default {
    privacyLinkLabel: "Datenschutz-richtlinie",
    privacyLink: '/de-de/about/legal/privacy/',
    privacyText: "Citrix wird Ihre Daten nur in Übereinstimmung mit unserer",
    privacyText2 : " verarbeiten.",
    resetText: "Wenn das Formular bereits ausgefüllt ist, die Angaben aber nicht zu Ihnen passen, klicken Sie bitte",
    resetText2: ", um das Formular zurückzusetzen.",
    resetLinkText: "hier",
    yes: "Ja",
    no: "Nein",
    submitBtn: {
        "Submit" : "Absenden",
        "Get the eBook" : "E-Book herunterladen",
        "Watch demo" : "Sehen Sie die Demo",
        "Get the kit" : "Besorgen Sie sich das Kit",
        "Compare now" : "Jetzt vergleichen",
        "Request a demo": "Demo anfordern",
        "Request a call": "Einen Rückruf anfordern"
    },
    apjPrivacy:{
        title: "So nutzen wir Ihre persönlichen Informationen",
        company: "Citrix Systems Japan K.K.",
        part1: "(\"Citrix\") wird Ihre persönlichen Informationen anhand der anwendbaren Datenschutzgesetze und -vorschriften sowie der",
        linkText: "Citrix Datenschutzrichtlinie",
        part2: "sowie unter Bedingungen nutzen und speichern, in denen der Zugriff streng beschränkt ist. Citrix wird Ihre persönlichen Informationen ausschließlich gemäß der Datenschutzrichtlinie nutzen und für keine anderen Zwecke einsetzen. Gemäß seiner Datenschutzrichtlinie kann Citrix die Verarbeitung persönlicher Informationen inländischen oder ausländischen Geschäftsbereichen überlassen, persönliche Informationen mit anderen Citrix Niederlassungen oder Tochterunternehmen weltweit austauschen oder persönliche Informationen an dritte Parteien im In- oder Ausland senden. Wenn Sie Ihre persönlichen Informationen an Citrix übermitteln, stimmen Sie der Erfassung und Verarbeitung dieser Informationen gemäß der Citrix Datenschutzrichtlinie zu.",
        privacyAccept: "Ich habe die Citrix Datenschutzrichtlinie gelesen und stimme ihr zu"
    },
    fields: {
        "AnnualSales": {
            label: "Annual Sales"
        },
        "Company_Self_Reported__c": {
            label: "Unternehmensname"
        },
        "department": {
            label: "Abteilung",
            options: [
                { value: "Application Management", text: "Anwendungsmanagement" },
                { value: "Consulting Services", text: "Consulting Services" },
                { value: "Education / Training", text: "Ausbildung / Training" },
                { value: "Engineering", text: "Technik / Konstruktionswesen" },
                { value: "Executive Office / Administration", text: "Executive Office / Administration" },
                { value: "Finance / Accounting", text: "Finanzen / Rechnungswesen" },
                { value: "Human Resources", text: "Personalwesen" },
                { value: "Information Technology - Systems", text: "Informationstechnologie-Systeme" },
                { value: "Legal", text: "Rechtliche Informationen" },
                { value: "Marketing / PR", text: "Marketing / PR" },
                { value: "Networking", text: "Networking" },
                { value: "Operations / Manufacturing", text: "Operations / Fertigung" },
                { value: "Pre-Sales / Technical Support", text: "Pre-Sales / Technischer Support" },
                { value: "Project Management", text: "Projektmanagement" },
                { value: "Purchasing", text: "Einkauf" },
                { value: "Sales / Bus-Corp Development", text: "Vertrieb / Unternehmensentwicklung" },
                { value: "Security", text: "Sicherheit" },
                { value: "Web / Online / E-Business", text: "Web / Online / E-Business" }
            ]
        },
        "Industry_Self_Reported__c": {
            label: "Branche",
            options: [
                { value: "Construction and Design", text: "Bau" },
                { value: "Government/State-Province", text: "Behörden – Bundesland/Provinz" },
                { value: "Government/Local", text: "Behörden – regional" },
                { value: "Government/National-Federal", text: "Behörden – Staats- und Bundesebene" },
                { value: "Mining - All", text: "Bergbau – alle" },
                { value: "Chemical Manufacturing", text: "Chemische Industrie" },
                { value: "Professional Services", text: "Dienstleistungen für Unternehmen" },
                { value: "Business/Personal Services", text: "Dienstleistungen für Unternehmen und Privatkunden" },
                { value: "E-Commerce", text: "E-Commerce" },
                { value: "Retail/Wholesale", text: "Einzel- und Großhandel" },
                { value: "Oil and Gas", text: "Erdöl- und Erdgasförderung" },
                { value: "Finance", text: "Finanzen" },
                { value: "Hospitality", text: "Gastronomie / Hotellerie" },
                { value: "Charitable/Non-Profit", text: "Gemeinnützige Non-Profit-Organisationen" },
                { value: "Health Care", text: "Gesundheitswesen" },
                { value: "Household Services", text: "Haushaltsnahe Dienstleistungen" },
                { value: "Real Estate", text: "Immobilienmakler" },
                { value: "Consumer Packaged Goods", text: "Konsumgüter" },
                { value: "Agriculture", text: "Landwirtschaft" },
                { value: "Conglomerate", text: "Mischkonzern" },
                { value: "Utilities", text: "Öffentliche Versorger" },
                { value: "Personnel Services", text: "Personaldienstleistungen" },
                { value: "Pharmaceuticals", text: "Pharmazeutische Industrie" },
                { value: "Manufacturing", text: "Produktion" },
                { value: "Publishing/Printing", text: "Publizistik / Verlagswesen" },
                { value: "Legal", text: "Rechtliche Informationen" },
                { value: "Service Provider", text: "Service Provider" },
                { value: "Engineering", text: "Technik / Konstruktionswesen" },
                { value: "Art & Membership", text: "Technische Büros, beratende Ingenieure und Architekten" },
                { value: "Technology", text: "Technologie" },
                { value: "Telecommunication", text: "Telekommunikation" },
                { value: "Transportation", text: "Transport" },
                { value: "Entertainment", text: "Unterhaltungsbranche" },
                { value: "Business Consulting", text: "Unternehmensberatung" },
                { value: "Education", text: "Unterricht und Ausbildung" },
                { value: "Insurance", text: "Versicherungswesen" }
            ]
        },
        "NumberOfEmployees_Self_Reported__c" : {
            label: "Unternehmensgröße",
            options: [
                { value: "50", text: "1-50" },
                { value: "500", text: "51-500" },
                { value: "749", text: "501-749" },
                { value: "4999", text: "750-4,999" },
                { value: "19999", text: "5,000-19,999" },
                { value: "20000", text: "20,000+" }
            ]
        },
        "NumberofEmployees__here___atlocation": {
            label: "Unternehmensgröße",
            options: [
                { value: "5,001 +", text: "5.001 +" },
                { value: "1,001 to 5,000", text: "1.001 bis 5.000" },
                { value: "501 to 1,000", text: "501 bis 1.000" },
                { value: "251 to 500", text: "251 bis 500" },
                { value: "1 to 250", text: "1 bis 250" }
            ]
        },
        "Address2": {
            label: "Adresszeile 2"
        },
        "Address3": {
            label: "Adresszeile 3"
        },
        "city": {
            label: "Stadt"
        },
        "country": {
            label: "Land"
        },
        "email": {
            label: "Geschäftliche E-Mail-Adresse"
        },
        "firstName": {
            label: "Vorname"
        },
        "lastName": {
            label: "Nachname"
        },
        "phone": {
            label: "Telefonnummer"
        },
        "mobilePhone": {
            label: "Mobile Phone"
        },
        "postalCode": {
            label: "Postleitzahl"
        },
        "salutation": {
            label: "Anrede",
            options: [
                { value: "", text: ""},
                { value: "Dr.", text: "Dr."},
                { value: "Egr. Sig.", text: "Egr. Sig."},
                { value: "Frau", text: "Frau"},
                { value: "Gent.ma Sig.ra", text: "Gent.ma Sig.ra"},
                { value: "Herr", text: "Herr"},
                { value: "Madame", text: "Madame"},
                { value: "Mademoiselle", text: "Mademoiselle"},
                { value: "Miss", text: "Miss"},
                { value: "Monsieur", text: "Monsieur"},
                { value: "Mr.", text: "Mr."},
                { value: "Mrs.", text: "Mrs."},
                { value: "Ms.", text: "Ms."},
                { value: "Professor", text: "Professor"},
                { value: "Señor", text: "Señor"},
                { value: "Señora", text: "Señora"}
            ]
        },
        "state": {
            label: "Bundesland"
        },
        "address": {
            label: "Adresse"
        },
        "Job_Title__c": {
            label: "Stellenbezeichnung",
            options: [
                { value: "Analyst", text: "Analyst" },
                { value: "Architect", text: "Architekt" },
                { value: "Assistant", text: "Assistent" },
                { value: "Consultant", text: "Berater" },
                { value: "Business Manager", text: "Business Manager" },
                { value: "Owner / Partner", text: "Eigentümer / Miteigentümer" },
                { value: "Developer / Programmer", text: "Entwickler / Programmierer" },
                { value: "Director", text: "Geschäftsführer / Vorstand" },
                { value: "IT Manager", text: "IT-Manager" },
                { value: "C-Level / President / VP", text: "Mitglied der obersten Führungsebene / President / VP" },
                { value: "Network Administrator / Engineer", text: "Netzwerkadministrator / -ingenieur" },
                { value: "Student", text: "Student" },
                { value: "System Administrator", text: "Systemadministrator" }
            ]
        },
        "Project_Budget__c": {
            label: "Projektbudget",
            options: [
                { value: "Yes", text: "Ja" },
                { value: "No", text: "Nein" },
                { value: "Unknown", text: "Nicht bekannt" }
            ]
        },
        "Primary_Product_Interest__c": {
            label: "Halten Sie die CTRL-Taste, um mehr als eine Auswahl zu treffen (maximal 5 Optionen)"
        },
        "Purchase_Timeframe__c": {
            label: "Kaufzeitraum",
            options: [
                { value: "3 months or less", text: "Bis 3 Monate" },
                { value: "4 to 6 months", text: "4 bis 6 Monate" },
                { value: "7 months or more", text: "7 Monate oder mehr" },
                { value: "No time frame", text: "Kein Zeitrahmen" },
                { value: "Unknown", text: "Nicht sicher" }
            ]
        },
        "Email_Blast_OK__c": {
            label: "Dürfen wir Sie per E-Mail kontaktieren?",
            options: [
                { value: "Yes", text: "Ja" },
                { value: "No", text: "Nein" },
            ]
        },
        "Direct_Mail_OK__c": {
            label: "May we contact you by mail?",
            options: [
                { value: "Yes", text: "Ja" },
                { value: "No", text: "Nein" },
            ]
        },
        "OK_to_Call__c": {
            label: "Dürfen wir Sie telefonisch kontaktieren?",
            options: [
                { value: "Yes", text: "Ja" },
                { value: "No", text: "Nein" },
            ]
        },
        "Preferred_Language__c": {
            label: "Preffered language"
        },
        "Sales_Contact_Requested__c": {
            label: "Ich möchte von einem Vertriebsmitarbeiter kontaktiert werden"
        },
        "Comments_6__c":{
            label: "Kommentare"
        },
        //PrefCenter fields/options
        "Unsubscribed": {
            label: "Alle Marketing-E-Mails abbestellen.",
            options: [...yesNoOptions]
        },
        "Marketing_Suspended_30_Days__c": {
            label: "Mitteilungen für 30 Tage aussetzen.",
            options: [...yesNoOptions]
        },
        "Preferred_Topic_Workspace__c": {
            label: "So erreichen Sie mit vollständig digitalen Arbeitsplätzen – einschließlich Anwendungen, Desktops, Dateien und Mobilgeräten –, Höchstleistungen an jedem Standort.",
            options: [...yesNoOptions]
        },
        "Preferred_Topic_VirtualAppsDesktops__c": {
            label: "So erhalten Sie über jedes Gerät sicheren Zugriff auf Anwendungen, Desktops und Daten.",
            options: [...yesNoOptions]
        },
        "Preferred_Topic_NetworkingADC__c": {
            label: "So verwalten Sie die Bereitstellung monolithischer und Microservice-basierter Anwendungen in einer hybriden Multi-Cloud-Umgebung.",
            options: [...yesNoOptions]
        },
        "Preferred_Topic_SDWan__c": {
            label: "So stellen Sie die leistungsfähigen Always-On-Netzwerke bereit, die Ihre Benutzer benötigen.",
            options: [...yesNoOptions]
        },
        "Preferred_Topic_Analytics__c": {
            label: "So nutzen Sie Analysen und Erkenntnisse, um Sicherheitsbedrohungen und Performance-Anomalien zu erkennen und im Keim zu ersticken.",
            options: [...yesNoOptions]
        }
    },
    optOut: {
        formTitle: "Abmelden",
        thankyou: "Ihre E-Mail-Einstellungen wurden aktualisiert. Wenn Sie die Änderungen rückgängig machen oder Ihre Einstellungen noch einmal prüfen möchten, können Sie dazu jederzeit unsere Benachrichtigungseinstellungen aufrufen.",
        formDescription: "Wir finden es schade, dass Sie gehen. Besuchen Sie uns doch bei Gelegenheit auf Citrix.de. Wir fügen ständig neue Features und Funktionen hinzu, um die Citrix Produkte für Sie zu optimieren.",

    },
    preferenceCenter: {
        formTitle: "Citrix E-Mail-Benachrichtigungseinstellungen",
        thankyou: "<h3>Abonnementänderungen bestätigt!</h3><p>Ihre E-Mail-Einstellungen wurden aktualisiert.</p>",
        formDescription: "Ihre E-Mail- und Kommunikationseinstellungen sind uns ein wichtiges Anliegen. Wir möchten Ihnen Informationen senden, die Ihnen und Ihrer Organisation ermöglichen, besser zu arbeiten.  Wenn Sie Ihre E-Mail-Einstellungen auf dem neuesten Stand halten, können wir Ihnen die Mitteilungen von Citrix senden, die Ihnen wichtig sind.",
        labelOne: "Erzählen Sie uns mehr über sich",
        labelTwo: "Welche Themen interessieren Sie am meisten?",
        labelThree: "Wie möchten Sie am liebsten benachrichtigt werden?",
    },
    validation: validationMessages
}